"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useOutsideClick;

var _react = require("react");

var _helpers = require("./helpers");

function useOutsideClick(target, onOutsideClick) {
  var isListening = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var listener = (0, _react.useCallback)(function (event) {
    var targetElement = (0, _helpers.getTarget)(target);

    if ((0, _helpers.isDomElement)(targetElement) && !targetElement.contains(event.target)) {
      onOutsideClick(event);
    }
  }, // eslint-disable-next-line react-hooks/exhaustive-deps
  [target]);
  (0, _react.useEffect)(function () {
    if (isListening) {
      document.addEventListener('mousedown', listener);
      document.addEventListener('touchstart', listener);
    }

    return function () {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [isListening, listener]);
}